<section>
  <button type="button" class="btn btn-back d-flex align-items-center py-5" [routerLink]="['/residences']"
    routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png"> <span class="mx-4">Back</span>
  </button>


  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">

      <div class="row d-flex align-items-center flex-wrap">
        <div class="col-12 col-md-12 col-lg-6">
          <div class="d-flex align-items-start flex-column mb-3">
            <div class="mb-auto p-2 heading-1">{{ ItemDetail.name }}</div>
            <div class="p-2">
              <div class="d-flex">
                <i class="ri-map-pin-line" style="color: var(--color-green-dark);"></i>

                <span class="title px-2">
                  {{ ItemDetail.address }}
                </span>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6">

          <div class="row justify-content-end">
            <div class="col-12 col-md-8 col-lg-8"> <!-- (col-xl-7) -->
              <div class="dashboard-card" style="overflow: visible; position: relative;"
                (click)="openGalleryModal(galleryModal)">
                <i class="ri-arrow-right-up-line arrow-icon-gallery"></i>
                <div class="row">
                  <div
                    class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-sm-center">
                    <div class="hotel-image-container">
                      <ul class="photo-stack-grid">
                        <li>
                          <a>
                            <figure class="photo-stack">
                              <!-- <img [src]="firstFilePath" alt="Picture" /> -->

                              <div [ngSwitch]="!!firstFilePath">
                                <img *ngSwitchCase="false" src="assets/images/Empty-State.png" alt="Empty building">
                                <img *ngSwitchDefault [src]="firstFilePath" alt="Picture">
                              </div>
                            </figure>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-12 col-md-7 col-lg-7">
                    <div class="stats-container">
                      <div class="section-title">Total Unit</div>
                      <div class="stats-value">{{ ItemDetail.total_unit }}</div>
                      <i class="fa-solid fa-arrow-up-right arrow-icon"></i>

                      <div class="row">
                        <div class="col-6 col-md-6 col-lg-6">
                          <div class="section-title mt-4">Unit Sold</div>
                          <div class="stats-value">{{ ItemDetail.sold_unit }}</div>
                        </div>
                        <div class="col-6 col-md-6 col-lg-6">
                          <div class="section-title mt-4">Available Unit</div>
                          <div class="stats-value">{{ ItemDetail.available_unit }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row my-4">
        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-property">
            
            <div class="card-header">
                <h5 class="card-title align-items-center card-title-custom">
                    <img src="assets/icons/pie-chart.png"> Sales Revenue
                </h5>
            </div>
            <div *ngIf="!isLoading && ItemSummaryDetail.length > 0" style="padding-left:  15px; padding-right: 15px;">
              <!-- TOTAL SECTION (Modified) -->
              <div class="container-fluid container-box-progress" *ngFor="let item of totalRevenueOnly">
                
                <!-- Header dengan master toggle -->
                <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                  <div class="col-5 title-text">
                    {{ item.unit_type_name }}
                    <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                  </div>
                  <div class="col-7 total-text">{{ item.curr_revenue| rupiah }}</div>
                </div>
                <!-- As Of Section -->
                <div class="metric-group">
                  <div class="remarks-text">{{ item.total_remark }}</div>
                  <div class="percentage-value-wrapper">
                    <span class="value-text">{{ item.total_revenue | rupiah }}</span>
                    <span class="percentage-text" [class]="getPercentageClass(item.total_revenue_pctg)">
                      {{ item.total_revenue_pctg | rupiah }}
                    </span>
                    
                    <!-- Tooltip hanya muncul jika total_revenue_pctg !== 100 -->
                    <span class="value-text" 
                          *ngIf="item.total_revenue_pctg !== 100"
                          data-bs-toggle="tooltip" 
                          data-bs-placement="top" 
                          title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                      {{ item.potential_revenue | rupiah }}
                      <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                    </span>
                    
                    <!-- Tanpa tooltip jika total_revenue_pctg === 100 -->
                    <span class="value-text" 
                          *ngIf="item.total_revenue_pctg === 100">
                      {{ item.potential_revenue | rupiah }}
                    </span>
                  </div>
                </div>
                
                
                <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                <div *ngIf="isTotalExpanded">
                  <!-- mast month Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.lm_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.lm_revenue_pctg)">
                        {{ item.lm_revenue_pctg }}%
                      </span>
                      <span class="value-text">{{ item.lm_revenue| rupiah }}</span>
                    </div>
                  </div>

                  <!-- Last Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ly_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.ly_revenue_pctg)">
                        {{ item.ly_revenue_pctg }}%
                      </span>
                      <span class="value-text">{{ item.ly_revenue | rupiah }}</span>
                    </div>
                  </div>

                  <!-- This Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ty_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.ty_revenue | rupiah }}</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.ty_revenue_pctg)">
                        {{ item.ty_revenue_pctg }}%
                      </span>

                      <!-- Tooltip hanya muncul jika ty_revenue_pctg !== 100 -->
                      <span class="value-text" 
                            *ngIf="item.ty_revenue_pctg !== 100"
                            data-bs-toggle="tooltip" 
                            data-bs-placement="top" 
                            title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                        {{ item.potential_revenue | rupiah }}
                        <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                      </span>
                      
                      <!-- Tanpa tooltip jika ty_revenue_pctg === 100 -->
                      <span class="value-text" 
                            *ngIf="item.ty_revenue_pctg === 100">
                        {{ item.potential_revenue | rupiah }}
                      </span>
                    </div>
                  </div>                
                </div>  
              </div>
              <div class="mb-3 revenue-item-card" *ngFor="let item of ItemSummaryDetail; let i = index">
                <div *ngIf="item.unit_type_name !== 'Total'" style="padding-top: 20px;">
                  <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ item.unit_type_name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                    </div>
                    <div class="col-7 total-text">{{ item.curr_revenue| rupiah }}</div>
                  </div>

                  <div class="metric-group">
                    <div class="remarks-text remarks-with-padding">{{ item.total_remark }} </div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.total_revenue | rupiah }}</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.total_revenue_pctg)">
                        {{ item.total_revenue_pctg }}%
                      </span>

                      <!-- Tooltip hanya muncul jika total_revenue_pctg !== 100 -->
                      <span class="value-text" 
                            *ngIf="item.total_revenue_pctg !== 100"
                            data-bs-toggle="tooltip" 
                            data-bs-placement="top" 
                            title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                        {{ item.potential_revenue | rupiah }}
                        <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                      </span>
                      
                      <!-- Tanpa tooltip jika total_revenue_pctg === 100 -->
                      <span class="value-text" 
                            *ngIf="item.total_revenue_pctg === 100">
                        {{ item.potential_revenue | rupiah }}
                      </span>
                      
                    </div>
                  </div>
                  
                  <div *ngIf="expandedStates[i]">
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.lm_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text"></span>
                        <span class="percentage-text" [class]="getPercentageClass(item.lm_revenue_pctg)">
                          {{ item.lm_revenue_pctg }}%
                      </span>
                        <span class="value-text">{{ item.lm_revenue | rupiah }}</span>
                      </div>
                    </div>
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ly_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.ly_revenue_pctg)">
                          {{ item.ly_revenue_pctg }}%
                        </span>
                        <span class="value-text">{{ item.ly_revenue | rupiah }}</span>
                      </div>
                    </div>
                    <div class="metric-group last-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ty_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text">{{ item.ty_revenue | rupiah }}</span>
                        <span class="percentage-text" [class]="getPercentageClass(item.ty_revenue_pctg)">
                          {{ item.ty_revenue_pctg }}%
                        </span>
                        <!-- Tooltip hanya muncul jika total_revenue_pctg !== 100 -->
                        <span class="value-text" 
                              *ngIf="item.ty_revenue_pctg !== 100"
                              data-bs-toggle="tooltip" 
                              data-bs-placement="top" 
                              title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                          {{ item.potential_revenue | rupiah }}
                          <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                        </span>
                        
                        <!-- Tanpa tooltip jika total_revenue_pctg === 100 -->
                        <span class="value-text" 
                              *ngIf="item.ty_revenue_pctg === 100">
                          {{ item.potential_revenue | rupiah }}
                        </span>
                      </div>
                    </div>
                    
                  </div>  
                </div>  
              </div>
            </div>
            
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-property">
            
            <div class="card-header">
                <h5 class="card-title align-items-center card-title-custom">
                    <img src="assets/icons/pie-chart.png"> Sales Unit
                </h5>
            </div>
            
            <div *ngIf="!isLoading && ItemSummaryDetail.length > 0" style="padding-left:  15px; padding-right: 15px;">
              <!-- TOTAL SECTION (Modified) -->
              <div class="container-fluid container-box-progress" *ngFor="let item of totalRevenueOnly; let i = index">
                
                <!-- Header dengan master toggle -->
                <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                  <div class="col-5 title-text">
                    {{ item.unit_type_name }}
                    <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                  </div>
                  <div class="col-7 total-text">{{ item.curr_sold_unit }} Unit</div>
                </div>
                <!-- As Of Section -->
                <div class="metric-group">
                  <div class="remarks-text">{{ item.total_remark }}</div>
                  <div class="percentage-value-wrapper">
                    <span class="value-text">{{ item.total_sold_unit }} Unit</span>
                    <span class="percentage-text" [class]="getPercentageClass(item.total_sales_pctg)">
                      {{ item.total_sales_pctg }}%
                    </span>
                    <span class="value-text">{{ item.total_unit }} Unit</span>
                  </div>
                </div>
                
                
                <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                <div *ngIf="expandedStates[i]">
                  <!-- mast month Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.lm_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.lm_sales_pctg)">
                        {{ item.lm_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.lm_sold_unit }} Unit</span>
                    </div>
                  </div>

                  <!-- Last Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ly_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.ly_sales_pctg)">
                        {{ item.ly_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.ly_sold_unit }} Unit</span>
                    </div>
                  </div>

                  <!-- This Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ty_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.ty_sold_unit }} Unit</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.ty_sales_pctg)">
                        {{ item.ty_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.total_unit }} Unit</span>
                    </div>
                  </div>                
                </div>  
              </div>
              <div class="mb-3 revenue-item-card" *ngFor="let item of ItemSummaryDetail; let i = index">
                <div *ngIf="item.unit_type_name !== 'Total'" style="padding-top: 20px;">
                  <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ item.unit_type_name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                    </div>
                    <div class="col-7 total-text">{{ item.curr_sold_unit }} Unit</div>
                  </div>

                  <div class="metric-group">
                    <div class="remarks-text remarks-with-padding">{{ item.total_remark }} </div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.total_sold_unit }} Unit</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.total_sales_pctg)">
                        {{ item.total_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.total_unit }} Unit</span>
                    </div>
                  </div>
                  
                  <div *ngIf="expandedStates[i]">
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.lm_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text"></span>
                        <span class="percentage-text" [class]="getPercentageClass(item.lm_sales_pctg)">
                          {{ item.lm_sales_pctg }}%
                      </span>
                        <span class="value-text">{{ item.lm_sold_unit }} Unit</span>
                      </div>
                    </div>
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ly_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.ly_sales_pctg)">
                          {{ item.ly_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ item.ly_sold_unit }} Unit</span>
                      </div>
                    </div>
                    <div class="metric-group last-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ty_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text">{{ item.ty_sold_unit }} Unit</span>
                        <span class="percentage-text" [class]="getPercentageClass(item.ty_sales_pctg)">
                          {{ item.ty_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ item.total_unit }} Unit</span>
                      </div>
                    </div>
                    
                  </div>  
                </div>  
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4"> <!--TW20250924-->
          <div class="card card-occupancy">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/occupancy-lease.png"> Sales Percentage
              </h5>
              <div class="container-fluid container-box-progress" *ngIf="ItemsOccupancy">
                <div class="row">
                  <!-- Header dengan master toggle -->
                  <div class="row header-row" (click)="toggleExpand(0)" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ ItemsOccupancy.name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[0]" [class.fa-chevron-up]="expandedStates[0]"></i>
                    </div>
                    <div class="col-7 total-text">{{ ItemsOccupancy.curr_pct}}%</div>
                  </div>
                  
                  <!-- as of Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ ItemsOccupancy.total_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.total_sales_pctg)">
                      </span>
                      <span class="value-text">{{ ItemsOccupancy.total_sales_pctg }}%</span>
                    </div>
                  </div>
                  
                  <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                  <div *ngIf="expandedStates[0]">
                    <!-- Last Month Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemsOccupancy.lm_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.lm_sales_pctg)">
                          {{ ItemsOccupancy.lm_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ ItemsOccupancy.lm_pct}}%</span>
                      </div>
                    </div>
                    <!-- Last Year Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemsOccupancy.ly_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.ly_sales_pctg)">
                          {{ ItemsOccupancy.ly_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ ItemsOccupancy.ly_pct}}%</span>
                      </div>
                    </div>

                    <!-- This Year Section -->
                    <div class="metric-group last-group">
                      <div class="remarks-text">{{ ItemsOccupancy.ty_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.ty_sales_pctg)">
                          
                        </span>
                        <span class="value-text">{{ ItemsOccupancy.ty_sales_pctg}}%</span>
                      </div>
                    </div>
                  </div>  
                </div>
              </div>

              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingPercentage" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading occupancy data...</span>
                        </div>
                      </div>

                      <apx-chart *ngIf="!isLoadingPercentage" [series]="chartOptions.series" 
                        [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels" 
                        [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis" 
                        [xaxis]="chartOptions.xaxis" [legend]="chartOptions.legend"
                        [colors]="chartOptions.colors" [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        <!--<div class="col-12 col-md-12 col-lg-4">
          <div class="card card-occupancy">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/average.png"> Sales Percentage
              </h5>
              <div class="container-fluid container-box-progress mt-3">
                <div class="row">
                  <div class="col-12 col-md-5 col-lg-5">
                    <div class="col-6 col-md-6 d-flex flex-column justify-content-center">
                      <span class="title-date">
                        {{ startDate | dateformat }} - {{ endDate | dateformat }}
                      </span>
                      <span class="title-percent-progress mt-1">
                        {{ ItemSalesPercentage.real_amount }}%
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-md-7 col-lg-7 d-flex justify-content-end">
                    <div class="d-flex flex-column align-items-end">
                      <div class="d-flex">
                        <div [ngSwitch]="true">
                          <i *ngSwitchCase="ItemSalesPercentage.budget_percentage === 0" class="percent-success"></i>
                          <i *ngSwitchCase="ItemSalesPercentage.budget_percentage && ItemSalesPercentage.budget_percentage.toString().startsWith('-')"
                            class="fas fa-arrow-down fa-xs" style="color: var(--color-red-dark);"></i>
                          <i *ngSwitchDefault class="fas fa-arrow-up fa-xs" style="color: var(--color-green-dark);"></i>
                        </div>

                        <div [ngSwitch]="true">
                          <span *ngSwitchCase="ItemSalesPercentage.budget_percentage === 0" class="percent-success">{{
                            ItemSalesPercentage.budget_percentage }}</span>
                          <span
                            *ngSwitchCase="ItemSalesPercentage.budget_percentage && ItemSalesPercentage.budget_percentage.toString().startsWith('-')"
                            class="percent-danger">{{ ItemSalesPercentage.budget_percentage }}</span>
                          <span *ngSwitchDefault class="percent-success">+{{ ItemSalesPercentage.budget_percentage
                            }}</span>
                        </div>
                      </div>
                      <h5 class="title-under-badge">{{ ItemSalesPercentage.remarks }}</h5>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingPercentage" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading percentage data...</span>
                        </div>
                      </div>

                      <apx-chart *ngIf="!isLoadingPercentage" [series]="chartSalesPercentage.series"
                        [chart]="chartSalesPercentage.chart" [dataLabels]="chartSalesPercentage.dataLabels"
                        [plotOptions]="chartSalesPercentage.plotOptions" [yaxis]="chartSalesPercentage.yaxis"
                        [xaxis]="chartSalesPercentage.xaxis" [legend]="chartSalesPercentage.legend"
                        [colors]="chartOptions.colors" [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div> -->
      
      </div>
    </div>
  </div>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">
      <h1 class="heading-1">Unit Properties Informations</h1>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="sortable-header" (click)="onSort('unit_name')">
                <span>Unit Name</span>
                <i [class]="getSortIcon('unit_name')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('land_size')">
                <span>Land Size</span>
                <i [class]="getSortIcon('land_size')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('building_size')">
                <span>Building Size</span>
                <i [class]="getSortIcon('building_size')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('nett_size')">
                <span>Nett Size</span>
                <i [class]="getSortIcon('nett_size')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('selling_price')">
                <span>Selling Price</span>
                <i [class]="getSortIcon('selling_price')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('total_unit')">
                <span>Total Unit</span>
                <i [class]="getSortIcon('total_unit')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('sold_unit')">
                <span>Sold Unit</span>
                <i [class]="getSortIcon('sold_unit')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('available_unit')">
                <span>Available Unit</span>
                <i [class]="getSortIcon('available_unit')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('status')">
                <span>Status</span>
                <i [class]="getSortIcon('status')" class="sort-icon"></i>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && ItemResidences.length > 0">
            <tr *ngFor="let item of ItemResidences">
              <td class="text-start">{{ item.unit_name }}</td>
              <td class="text-center">{{ item.land_size | squareMeter }}</td>
              <td class="text-center">{{ item.building_size | squareMeter }}</td>
              <td class="text-center">{{ item.nett_size | squareMeter }}</td>
              <td class="text-end">{{ item.selling_price | rupiah }}</td>
              <td class="text-end">{{ item.total_unit }}</td>
              <td class="text-end">{{ item.sold_unit }}</td>
              <td class="text-end">{{ item.available_unit }}</td>
              <td class="text-end" [ngClass]="{'text-success': item.status === 'Available', 'text-danger': item.status === 'Sold Out'}">
                {{ item.status }}
              </td>
            </tr>

          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="10" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button" tabindex="0"
          *ngFor="let item of ItemResidences; let i = index">
          <div class="card-header card-sm-header">
            <h5>{{ item.unit_name }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div class="card-sm-title my-2">Land Size</div>
                <div class="card-sm-title my-2">Building Size</div>
                <div class="card-sm-title my-2">Nett Size</div>
                <div class="card-sm-title my-2">Selling Price</div>
                <div class="card-sm-title my-2">Total Unit</div>
                <div class="card-sm-title my-2">Sold Unit</div>
                <div class="card-sm-title my-2">Available Unit</div>
                <div class="card-sm-title my-2">Status</div>
              </div>
              <div class="col-6">
                <div class="card-sm-title my-2">{{ item.land_size | squareMeter }}</div>
                <div class="card-sm-title my-2">{{ item.building_size | squareMeter }}</div>
                <div class="card-sm-title my-2">{{ item.nett_size | squareMeter }}</div>
                <div class="card-sm-title my-2">{{ item.selling_price | rupiah }}</div>
                <div class="card-sm-title my-2">{{ item.total_unit }}</div>
                <div class="card-sm-title my-2">{{ item.sold_unit }}</div>
                <div class="card-sm-title my-2">{{ item.available_unit }}</div> 
                <div class="card-sm-title my-2" [ngClass]="{'text-success': item.status === 'Available', 'text-danger': item.status === 'Sold Out'}">
                  {{ item.status }}
                </div> 
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start total-page-number">
          <h5 class="pageCount">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </h5>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>


    </div>
  </div>

</section>

<ng-template #galleryModal let-modal>
  <div class="hotel-gallery-container">
    <div class="row g-0">
      <!-- Left panel with filters -->
      <div class="col-md-3 col-12 gallery-sidebar">
        <div class="p-3">
          <h4 class="mb-4">
            <i class="ri-door-open-line" style="color: var(--color-green-dark);"></i> Residence Gallery
          </h4>

          <!-- Filter buttons container -->
          <div class="filters-container">
            <button *ngFor="let category of categoryNames" class="filter-btn"
              [class.active]="currentFilter === category" (click)="filterImages(category)">
              {{ category }}
            </button>
          </div>
        </div>
      </div>

      <!-- Right panel with image display -->
      <div class="col-md-9 col-12 gallery-main">
        <!-- Close button -->
        <button type="button" class="btn-close gallery-close" aria-label="Close" (click)="modal.dismiss()"></button>

        <!-- Image container -->
        <div class="image-container" *ngIf="filteredImages != null">

          <img [src]="currentImage.src | imagePath" class="gallery-image">

          <!-- Navigation buttons -->
          <button class="nav-btn prev-btn" (click)="prev()">
            <i class="ri-arrow-left-line"></i>
          </button>
          <button class="nav-btn next-btn" (click)="next()">
            <i class="ri-arrow-right-line"></i>
          </button>

          <!-- Pagination info -->
          <div class="pagination-info">
            <span>{{ currentPage }} / {{ getTotalPages() }}</span>
          </div>
        </div>

        <!-- No images message -->
        <div class="no-images" *ngIf="filteredImages === null">
          <p>No images available for this category.</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>